import { Controller } from "@hotwired/stimulus";

export const getIdentifier = (filename) => {
    return filename
        .replace(/^.*[\\/]/, '') // Remove directory path
        .replace(/-controller\.js$/, '') // Remove '-controller.js' suffix
        .replace('_', '-');
}

export const registerLazyControllers = (application, context) => {
    context.keys().forEach((filename) => {
        const identifier = getIdentifier(filename);

        let modulePromise = null;

        const loadAndRegister = () => {
            if (modulePromise) return modulePromise;

            modulePromise = context(filename)
                .then((module) => {
                    application.register(identifier, module.default);
                })
                .catch((error) => {
                    modulePromise = null;
                    console.error(`[Stimulus] Failed to load controller "${identifier}":`, error);
                });

            return modulePromise;
        };

        application.register(identifier, class extends Controller {
            connect() {
                loadAndRegister();
            }
        });
    });
};